// extracted by mini-css-extract-plugin
module.exports = {"PurchaseSuccess":"PurchaseSuccess_PurchaseSuccess__2V4cw","mainArea":"PurchaseSuccess_mainArea__2jORq","btnBack":"PurchaseSuccess_btnBack__2nN6O"};